module.exports = __webpack_public_path__ + "img/topbar_head.9604a821.svg";